export class FreeFormAnswerModel {
  public questionId?: string;
  public origAnswerText?: string;
  public paraAnswerText?: string;
  public wasParaEdited?: boolean;

  constructor (questionId?: string, origAnswerText?: string, paraAnswerText?: string, wasParaEdited?: boolean) {
    this.questionId = questionId
    this.origAnswerText = origAnswerText
    this.paraAnswerText = paraAnswerText
    this.wasParaEdited = wasParaEdited || false
  }
}
